import renderMinicart from '../lib/renderMinicart';
import getCart from '../lib/getCart';
import updateCartCount from '../lib/updateCartCount';
import { HTTP } from '../utils/constants';

const handleExternalCartAdd = async () => {
  const [cart] = await Promise.all([getCart(), renderMinicart()]);
  if (cart?.item_count != null) updateCartCount(cart.item_count);
  window.theme.minicart?.open();
};

const safeHandleExternalCartAdd = async () => {
  try {
    await handleExternalCartAdd();
  } catch (e) {
    console.error(e);
  }
};

const interceptFetch = () => {
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url ?? '');
    const isThemeAtc = args[1]?.headers?.['X-Theme-ATC'] === '1';
    if (response.ok && !isThemeAtc && url.includes('/cart/add.js')) {
      safeHandleExternalCartAdd();
    }
    return response;
  };
};

const interceptXhr = () => {
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this._interceptUrl = url;
    return originalOpen.apply(this, [method, url, ...rest]);
  };

  // No X-Theme-ATC guard needed here — theme ATC uses fetch, not XHR.
  // Any XHR to /cart/add.js is therefore always external (e.g. Swym).
  XMLHttpRequest.prototype.send = function(...args) {
    this.addEventListener('load', function() {
      const isSuccess = this.status >= HTTP.SUCCESS_MIN && this.status < HTTP.SUCCESS_MAX;
      if (isSuccess && this._interceptUrl?.includes('/cart/add.js')) {
        safeHandleExternalCartAdd();
      }
    });
    return originalSend.apply(this, args);
  };
};

const initSwymCartSync = () => {
  interceptFetch();
  interceptXhr();
};

export default initSwymCartSync;
